<div class="flex flex-col h-full gap-5">
	<ng-container *ngIf="!isInFileCreationFlow">
		<h1 class="h1 mb-1">Commissions</h1>
		<app-checkbox
			*ngIf="(fileType$ | async) === matterFileType.SALE"
			type="clear"
			label="Add Buyer Brokerage Commission Statement"
			[ngModel]="showBuyerBrokerage$ | async"
			(ngModelChange)="toggleBuyerBrokerageCommission($event)"
		></app-checkbox>
	</ng-container>
	<div
		class="flex justify-between"
		*ngIf="
			(fileType$ | async) === matterFileType.SALE &&
			(showBuyerBrokerage$ | async)
		"
	>
		<atomic-button-group
			[ngModel]="currentBrokerageSelection$ | async"
			[options]="mappedBrokerageSelectionOptions$ | async"
			(onClick)="onBrokerageSelection($event)"
			[testHook]="testHooks.ButtonGroup"
		></atomic-button-group>
	</div>
	<app-multiple-commissions
		[selectedBrokerageType]="currentBrokerageSelection$ | async"
	></app-multiple-commissions>
</div>
